

export const KlaviyoUserRegister = async (request) => {

  if (request.customer) {

    dataLayer.push({
      event: "klaviyo_user_registration",
      identify_email: request.customer.email,
      identify_first_name: request.customer.firstName,
      identify_last_name: request.customer.lastName,
    });
  }

};

export const KlaviyoUserSignIn = async (request) => {

  if (request.customer) {

    // dataLayer.push({
    //   event: "klaviyo_user_login",
    //   identify_email: request.customer.email,
    //   identify_first_name: request.customer.firstName,
    //   identify_last_name: request.customer.lastName,

    // });
  }
};

export const KlaviyoUserCartDetails = async (request, userEmail) => {
  let email = "guest"
  const product_details = {}
  if (request) {
    product_details.ProductName = request?.title,
      product_details.ProductID = parseInt(request?.id.toString().replace("gid://shopify/Product/", "")),
      product_details.SKU = request.sku,
      product_details.Categories = request?.named_tags?.category,
      product_details.ImageURL = request.ImageURL
    product_details.URL = request.ProductURL
    product_details.Brand = request?.vendor,
      product_details.Price = request?.price,
      product_details.CompareAtPrice = request?.compareAtPrice
  }

  if (userEmail) {
    email = userEmail
  }

  if (request) {

    dataLayer.push({
      event: "klaviyo_user_cart_details",
      identify_email: email,
      cart_details: product_details

    });
  }
};

export const KlaviyoUserRemoveFromCart = async (request, userEmail) => {
  let email = "guest"
  const product_details = {}

  if (request) {
    product_details.Brand = request?.merchandise?.product?.vendor,
      product_details.ProductID = parseInt(request?.merchandise?.product?.id.replace("gid://shopify/Product/", "")),
      product_details.ProductName = request?.merchandise?.product?.title,
      product_details.Price = request?.merchandise?.priceV2?.amount,
      product_details.quantity = request?.quantity
  }


  if (userEmail) {
    email = userEmail
  }

  if (request) {

    dataLayer.push({
      event: "klaviyo_user_remove_from_cart",
      identify_email: email,
      cart_details: product_details

    });
  }
};

export const Klaviyo_viewed_product = async (request, userEmail, url) => {
  let email = "guest"
  const product_details = {}

  if (request) {
    var str = JSON.stringify(request);
    str = str.replace(/categories.lvl0/g, 'category');
    str = str.replace(/categories.lvl1/g, 'subcategory');
    str = str.replace(/categories.lvl2/g, 'nestedsub');

    request = JSON.parse(str)
 
    product_details.ProductName = request?.title,
      product_details.ProductID = parseInt(request?.id.toString().replace("gid://shopify/Product/", "")),
      product_details.SKU = request.sku,
      product_details.Categories = [request?.named_tags?.category, request?.named_tags?.subcategory, request?.named_tags?.nestedsub,]
    product_details.ImageURL = request.image
    product_details.URL = `${url}/products/${request?.handle}`
    product_details.Brand = request?.vendor,
      product_details.Price = request?.price,
      product_details.CompareAtPrice = request.compare_at_price

  }


  if (userEmail) {
    email = userEmail
  }

  if (request) {

    dataLayer.push({
      event: "Klaviyo_viewed_product",
      cart_details: product_details

    });
  }
};

export const Klaviyo_wishlist = async (request, url, userEmail) => {
  let email = "guest"
  const product_details = {}

  if (request) {
    var str = JSON.stringify(request);
    str = str.replace(/categories.lvl0/g, 'category');
    str = str.replace(/categories.lvl1/g, 'subcategory');
    str = str.replace(/categories.lvl2/g, 'nestedsub');

    request = JSON.parse(str)

    product_details.ProductName = request?.title,
      product_details.ProductID = parseInt(request?.id.toString().replace("gid://shopify/Product/", "")),
      product_details.SKU = request.sku,
      product_details.Categories = [request?.named_tags?.category, request?.named_tags?.subcategory, request?.named_tags?.nestedsub,]
    product_details.ImageURL = request.image
    product_details.URL = `${url}/${request?.handle}`
    product_details.Brand = request?.vendor,
      product_details.Price = request?.price,
      product_details.CompareAtPrice = request.compare_at_price

  }



  if (request) {

    dataLayer.push({
      event: "klaviyo_user_wishlist",
      cart_details: product_details

    });
  }
};

export const Klaviyo_wishlist_remove = async (request, url, userEmail) => {
  let email = "guest"
  const product_details = {}

  if (request) {
    var str = JSON.stringify(request);
    str = str.replace(/categories.lvl0/g, 'category');
    str = str.replace(/categories.lvl1/g, 'subcategory');
    str = str.replace(/categories.lvl2/g, 'nestedsub');

    request = JSON.parse(str)

    product_details.ProductName = request?.title,
      product_details.ProductID = parseInt(request?.id.toString().replace("gid://shopify/Product/", "")),
      product_details.SKU = request.sku,
      product_details.Categories = [request?.named_tags?.category, request?.named_tags?.subcategory, request?.named_tags?.nestedsub,]
    product_details.ImageURL = request.image
    product_details.URL = `${url}/${request?.handle}`
    product_details.Brand = request?.vendor,
      product_details.Price = request?.price,
      product_details.CompareAtPrice = request.compare_at_price

  }



  if (request) {

    dataLayer.push({
      event: "klaviyo_user_wishlist_remove",
      cart_details: product_details

    });
  }
};

export const Klaviyo_track_user = async (userEmail) => {
  
  if (userEmail) {

    dataLayer.push({
      event: "klaviyo_track_user_everypage",
      identify_email: userEmail.email,
      identify_first_name: userEmail.firstName,
      identify_last_name:userEmail.lastName
    });
  }
};


export const KlaviyoPageView = async (request, userEmail) => {
  // alert(JSON.stringify(userEmail))

  if (request) {
    if(request === "/"){
      dataLayer.push({  
        event: "klaviyo_page_view_Homepage",
        page:request
  
      });
      return;
    }
    else if(request.includes("/product")){
      dataLayer.push({  
      event: "klaviyo_page_view_PDP",
      page:request

    });
    }
    else if(request.includes("/impact")){
      dataLayer.push({  
        event: "klaviyo_page_view_Impact",
        page:request
  
      });
    }
    else{
      dataLayer.push({  
        event: "klaviyo_page_view_PLP",
        page:request,
        'ecommerce': {
          'add': {
            'actionField': {
              'list': request
            }
          }
        }
      });
    }


    
  
    // dataLayer.push({  
    //   event: "klaviyo_user_cart_details",
    //   cart_details:request

    // });
  }
};
